import React, {useEffect, useState} from "react";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import {leerPropietarios, RespuestaLeerPropietarios} from "../../../services/propietariosServicios";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/propietarios",
        label: "Propietarios",
        isActive: true
    }
]

function ListaPropietarios(){
    const [propietarios, setPropietarios] = useState([] as RespuestaLeerPropietarios[]);

    useEffect(() => {
        async function poblarPropietarios() {
            const respuestasPropietarios = await leerPropietarios();
            if(respuestasPropietarios){
                setPropietarios(respuestasPropietarios);
            }
        }

        poblarPropietarios()
    }, []);

    return (
        <Page description="Visualiza, edita y crea propietarios" title="Propietarios" breadCrumbs={breadCrumbs}>
            <TableSection propietarios={propietarios} />
        </Page>
    );
}

export default ListaPropietarios;